import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import TableActions from "../../../components/Common/TableActions";
import CustomPagination from "../../../components/Common/CustomPagination";
import Filter from "../../../components/Common/Filter";
import { Link, useLocation } from "react-router-dom";
import dataHandler from "../../../hooks/dataHandler";
import { APPINTRO, REMOVEAPPINTRO } from "../../../services/ApiCalls";
import { AppIntoListFilterOptions } from "../../../utilities/const";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import { useTranslation } from "react-i18next";
import moment from "moment";

// status -> badge color mapping (API now returns active/inactive/archived)
const STATUS_BADGE_CLASS = {
  active: "bg-success",
  inactive: "bg-secondary",
  archived: "bg-dark",
};

const ManageAppIntro = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const {
    setBody,
    body,
    data,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: APPINTRO,
  });

  useEffect(() => {
    const queryPage = new URLSearchParams(location.search).get("page");

    if (queryPage) {
      setBody((p) => ({ ...p, page: Number(queryPage) }));
    }
  }, []);

  const column = [
    {
      head: t("manageRoom.columns.srNo"),
      accessor: "#",
      component: (item, key) => <>{key < 9 ? `0${key + 1}` : key + 1}</>,
    },
    {
      head: t("appIntro.columns.description"),
      accessor: "description",
      component: (item) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: "150px" }}
        >
          {item?.description}
        </span>
      ),
    },
    {
      head: t("appIntro.columns.title", "Title"),
      accessor: "title",
      component: (item) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: "150px" }}
        >
          {item?.title}
        </span>
      ),
    },
    {
      head: t("appIntro.columns.mediaCount"),
      accessor: "media",
      component: (item) => (
        <span className="d-flex justify-content-center align-items-center">
          {item?.media?.length ?? 0}
        </span>
      ),
    },
    {
      head: t("appIntro.columns.createdAt"),
      accessor: "createdAt",
      component: (item) => {
        // createdAt now comes back as a full ISO timestamp, e.g.
        // "2026-08-13T07:29:27.877Z" — parse it as a date, not a time-only string.
        const created = moment(item?.createdAt, moment.ISO_8601, true);

        return (
          <span className="d-flex justify-content-center align-items-center">
            {created.isValid() ? created.format("DD MMM YYYY, h:mm A") : "--"}
          </span>
        );
      },
    },
    {
      head: t("manageRoom.columns.status"),
      accessor: "status",
      component: (item) => (
        <span
          className={`badge text-capitalize ${
            STATUS_BADGE_CLASS[item?.status] || "bg-secondary"
          }`}
        >
          {item?.status}
        </span>
      ),
    },
    {
      head: t("manageRoom.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          editUrl={`/appintro/edit/${item._id}`}
          viewLink={`/appintro/detail/${item._id}?page=${body.page}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() => REMOVEAPPINTRO({ _id: deleteModel.dumpId }))
        }
      />
      <section className="room-management py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-end">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("appIntro.title")}
                </h4>

                {/* <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {t("manageRoom.filter")}
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-end justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    // searchHandler={searchHandler}

                    setBody={setBody}
                    statusFilterOptionArr={AppIntoListFilterOptions}
                  />
                </div>
                <div className="right d-flex align-items-end gap-3">
                  <Link
                    to="/appintro/add"
                    className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                    style={{ height: 40, minWidth: 100, fontSize: 12 }}
                  >
                    {t("appIntro.addAppIntro")}
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={column} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageAppIntro;